import Vue from 'vue';
import Amplify from 'aws-amplify';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import * as Feature from 'vue-feature-toggle';
import VueGtm from '@gtm-support/vue2-gtm';
import Vuelidate from 'vuelidate';
import { registerSidebar } from '@platform/sidebar';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './aws-exports';
import featureToggle from './feature-toggle';

import './assets/sass/main.scss';

import '@/components/globals';

Amplify.configure(config);

registerSidebar();
Vue.config.ignoredElements = ['app-sidebar'];

const isProduction = process.env.NODE_ENV === 'production';

Vue.config.productionTip = isProduction;

Feature.defaultVisibility((rule) => featureToggle[rule.name] === true);
Vue.component('feature', Feature);

Vue.use(Vuelidate);

Vue.use(
  VueGtm, {
    id: 'GTM-KFMBWPK',
    defer: false,
    enabled: false,
    debug: true,
    loadScript: true,
  },
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  Amplify,
  Feature,
  router,
  components: { App },
  template: '<App/>',
  store,
});

if (isProduction) {
  Sentry.init({
    dsn: 'https://94e7ec1aec1b4cb6bee5916eda7b9487@sentry.io/1841162',
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
    environment: process.env.NODE_ENV,
  });
}
